import React from 'react';
import CoverImage from '../CoverImage';
import Details from '../Details';
import FooterUpsell from '../FooterUpsell';
import Activities from '../Activities';
import Trophies from '../Trophies';
import Achievements from '../Achievements';
import MonthlyStats from '../MonthlyStats';

import styles from './ProfileEveryone.module.scss';

const ProfileEveryone = () => {
  return (
    <main role="main" data-testid="profile-everyone">
      <CoverImage />
      <div className={styles.container}>
        <div className={styles.row}>
          <div className={styles.athlete}>
            <Details />
          </div>
          <div className={styles.activities}>
            <Activities />
          </div>
          <div className={styles.metrics}>
            <div className={styles.section}>
              <MonthlyStats />
            </div>
            <div className={styles.section}>
              <Trophies />
            </div>
            <div className={styles.section}>
              <Achievements />
            </div>
          </div>
        </div>
      </div>
      <FooterUpsell />
    </main>
  );
};

export default ProfileEveryone;
